module.exports = __webpack_public_path__ + "img/1.17020a7a.jpg";